export default "__VITE_ASSET__Kq_FYlaP__"